import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import AppService from '../../../services/app';
import { cpfOrCnpjMask, unMask } from '../../../commons/masks';
import useForm from '../../components/useForm';
import AppForm from '../form';

const AppNewForm = (props) => {
  const [redirectTo, setRedirectTo] = useState(null);

  const initialFormValues = {
    cpf_cnpj: cpfOrCnpjMask(props.cpf||''),
    name: '',
    email: '',
    birthday: '',
    phone: '',
    password: ''
  }

  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm(initialFormValues);

  useEffect(() => {
    AppService.cleanAppCache();
  }, [])

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStatus('');
    setStateButton("loading");
    try {
      const data = {
        ...values,
        cpf_cnpj: unMask(values.cpf_cnpj),
        birthday: values.birthday.replace(/\//g, '-'),
        phone: unMask(values.phone)
      }
      const response = await AppService.register(data);
      setStatus(['success', response.data.message]);
    } catch(e) {
      setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
    }
    setStateButton('');
  }

  if (redirectTo)
    return <Redirect to={{pathname: redirectTo}} />

  const goToFind = () => setRedirectTo('/app/find');

  return (
    <AppForm 
      newRecord={true}
      status={status} 
      stateButton={stateButton} 
      values={values} 
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      handleClickBack={goToFind}
    />
  )

}

export default AppNewForm;

